import React from 'react'
import styled from 'styled-components'
import { Button } from '@nexiahome/ui-common/components/primitives/buttons'

import Modal from 'components/Modal'

interface Props {
  isOpen: boolean
  title?: string
  description: React.ReactNode
  okText?: string
  onClose: () => void
}

const AlertDialog = ({
  isOpen,
  title,
  description,
  okText = 'Ok',
  onClose
}: Props) => {
  return (
    <Modal
      variant="sm"
      fullWidth
      title={title}
      isDisplayed={isOpen}
      closeCallback={onClose}
      showCloseButton={false}
    >
      {description}
      <S.ButtonContainer>
        <Button decoration="positive" text={okText} onPress={onClose} />
      </S.ButtonContainer>
    </Modal>
  )
}

export default AlertDialog

const S = {
  ButtonContainer: styled.div`
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  `
}
